import React from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import { useDataProvider, useNotify, useRefresh, Confirm } from 'react-admin';
import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { setUploadPetImageId } from '../../Store/Slice/applicantDetailsSlice';

export default function DeleteFileConfirmBtn({
  doc_id,
  isArrayRemove = false,
  index = 1,
  invalidateQueries,
  tag,
  iconOnly = true,
  ...props
}) {
  const dataProvider = useDataProvider();
  const queryClient = useQueryClient();
  const notify = useNotify();
  const refresh = useRefresh();
  const dispatch = useDispatch();
  const [confirmDelete, setConfirmDelete] = React.useState(false);

  // react-query v3 drops the mutationFn (and options) entirely when the first
  // argument is undefined, so the key must always be a string
  const { mutate } = useMutation(tag || 'delete_document', (id) => dataProvider.deleteDocument(id), {
    retry: 1,
    retryDelay: 500,
    onSuccess: () => {
      setConfirmDelete(false);
      queryClient.invalidateQueries([`${invalidateQueries}`]);
      refresh();
      notify('Document deleted successfully...', {
        type: 'success',
        anchorOrigin: { vertical: 'top', horizontal: 'right' }
      });
      dispatch(
        setUploadPetImageId({
          index: props?.petIndex,
          id: doc_id,
          type: 'DELETE',
        })
      );
      if (props?.handleOnChange) {
        props?.handleOnChange();
      }
    },
    onError: () => {
      setConfirmDelete(false);
      alert('Fail deleting document');
    },
    onMutate: () => {
      notify('Document is Deleting...', {
        type: 'info',
        anchorOrigin: { vertical: 'top', horizontal: 'right' }
      });
    },
  });

  const { mutate: deleteDocumentNoDoc } = useMutation(tag || 'delete_document', (id) => dataProvider.deleteDocumentNoDoc(id), {
    onSuccess: () => {
      setConfirmDelete(false);
      queryClient.invalidateQueries([`${invalidateQueries}`]);
      props?.handleOnChange?.();
      notify('Document deleted successfully...', {
        type: 'success',
        anchorOrigin: { vertical: 'top', horizontal: 'right' }
      });
    },
    onError: () => {
      setConfirmDelete(false);
      alert('Fail deleting document');
    },
    onMutate: () => {
      notify('Document is Deleting...', {
        type: 'info',
        anchorOrigin: { vertical: 'top', horizontal: 'right' }
      });
    },
  });

  const handleDeleteDocument = (id) => {
    if (isArrayRemove) return deleteDocumentNoDoc(id);
    mutate(id);
  };

  return (
    <>
      <div className="print-hide" style={{ textAlign: 'center' }}>
        <button
          type="button"
          data-testid="delete-btn"
          title="Delete"
          onClick={() => setConfirmDelete(true)}
          className="icon-button delete-icon"
        >
          <DeleteIcon color='error' fontSize="medium" />
          {!iconOnly && (
            <span style={{ fontSize: 10, marginLeft: 4, color: 'red' }}>Delete</span>
          )}
        </button>
      </div>

      <Confirm
        isOpen={confirmDelete}
        sx={{ '& .RaConfirm-iconPaddingStyle': { display: 'none' } }}
        title="Confirm"
        content="Are you sure you want to delete this document?"
        onConfirm={() => handleDeleteDocument(doc_id)}
        onClose={() => setConfirmDelete(false)}
      />
    </>
  );
}
